export const getCatalog = () => ({
  type: "@saga/GET_CATALOG",
});
